import $894vb$arAEmodulejs from "./ar-AE.mjs";
import $894vb$bgBGmodulejs from "./bg-BG.mjs";
import $894vb$csCZmodulejs from "./cs-CZ.mjs";
import $894vb$daDKmodulejs from "./da-DK.mjs";
import $894vb$deDEmodulejs from "./de-DE.mjs";
import $894vb$elGRmodulejs from "./el-GR.mjs";
import $894vb$enUSmodulejs from "./en-US.mjs";
import $894vb$esESmodulejs from "./es-ES.mjs";
import $894vb$etEEmodulejs from "./et-EE.mjs";
import $894vb$fiFImodulejs from "./fi-FI.mjs";
import $894vb$frFRmodulejs from "./fr-FR.mjs";
import $894vb$heILmodulejs from "./he-IL.mjs";
import $894vb$hrHRmodulejs from "./hr-HR.mjs";
import $894vb$huHUmodulejs from "./hu-HU.mjs";
import $894vb$itITmodulejs from "./it-IT.mjs";
import $894vb$jaJPmodulejs from "./ja-JP.mjs";
import $894vb$koKRmodulejs from "./ko-KR.mjs";
import $894vb$ltLTmodulejs from "./lt-LT.mjs";
import $894vb$lvLVmodulejs from "./lv-LV.mjs";
import $894vb$nbNOmodulejs from "./nb-NO.mjs";
import $894vb$nlNLmodulejs from "./nl-NL.mjs";
import $894vb$plPLmodulejs from "./pl-PL.mjs";
import $894vb$ptBRmodulejs from "./pt-BR.mjs";
import $894vb$ptPTmodulejs from "./pt-PT.mjs";
import $894vb$roROmodulejs from "./ro-RO.mjs";
import $894vb$ruRUmodulejs from "./ru-RU.mjs";
import $894vb$skSKmodulejs from "./sk-SK.mjs";
import $894vb$slSImodulejs from "./sl-SI.mjs";
import $894vb$srSPmodulejs from "./sr-SP.mjs";
import $894vb$svSEmodulejs from "./sv-SE.mjs";
import $894vb$trTRmodulejs from "./tr-TR.mjs";
import $894vb$ukUAmodulejs from "./uk-UA.mjs";
import $894vb$zhCNmodulejs from "./zh-CN.mjs";
import $894vb$zhTWmodulejs from "./zh-TW.mjs";

var $a99895ee3dc79e61$exports = {};


































$a99895ee3dc79e61$exports = {
    "ar-AE": $894vb$arAEmodulejs,
    "bg-BG": $894vb$bgBGmodulejs,
    "cs-CZ": $894vb$csCZmodulejs,
    "da-DK": $894vb$daDKmodulejs,
    "de-DE": $894vb$deDEmodulejs,
    "el-GR": $894vb$elGRmodulejs,
    "en-US": $894vb$enUSmodulejs,
    "es-ES": $894vb$esESmodulejs,
    "et-EE": $894vb$etEEmodulejs,
    "fi-FI": $894vb$fiFImodulejs,
    "fr-FR": $894vb$frFRmodulejs,
    "he-IL": $894vb$heILmodulejs,
    "hr-HR": $894vb$hrHRmodulejs,
    "hu-HU": $894vb$huHUmodulejs,
    "it-IT": $894vb$itITmodulejs,
    "ja-JP": $894vb$jaJPmodulejs,
    "ko-KR": $894vb$koKRmodulejs,
    "lt-LT": $894vb$ltLTmodulejs,
    "lv-LV": $894vb$lvLVmodulejs,
    "nb-NO": $894vb$nbNOmodulejs,
    "nl-NL": $894vb$nlNLmodulejs,
    "pl-PL": $894vb$plPLmodulejs,
    "pt-BR": $894vb$ptBRmodulejs,
    "pt-PT": $894vb$ptPTmodulejs,
    "ro-RO": $894vb$roROmodulejs,
    "ru-RU": $894vb$ruRUmodulejs,
    "sk-SK": $894vb$skSKmodulejs,
    "sl-SI": $894vb$slSImodulejs,
    "sr-SP": $894vb$srSPmodulejs,
    "sv-SE": $894vb$svSEmodulejs,
    "tr-TR": $894vb$trTRmodulejs,
    "uk-UA": $894vb$ukUAmodulejs,
    "zh-CN": $894vb$zhCNmodulejs,
    "zh-TW": $894vb$zhTWmodulejs
};


export {$a99895ee3dc79e61$exports as default};
//# sourceMappingURL=intlStrings.module.js.map
